<template>
    <transition
        mode="out-in"
        enter-active-class="slide-in__bottom-block"
        leave-active-class="slide-out__bottom-block"
    >
        <template v-if="withdrawal">
            <template v-if="withdrawal.status === P_WITHDRAWAL_STATUS.CASHED">
                <div class="bottom-block">
                    <f7-button
                        class="theme-type"
                        :loading="submitWithdrawalLoading"
                        :disabled="submitWithdrawalLoading"
                        preloader
                        @click="confirmPayment"
                    >
                        {{ $t('withdrawal.statuses.cashed.actions.got') }}
                    </f7-button>
                </div>
            </template>
            <template v-else-if="withdrawal.status === P_WITHDRAWAL_STATUS.ONAPPEAL">
                <div class="bottom-block">
                    <f7-button
                        class="dark-grey-type"
                        :loading="submitWithdrawalLoading"
                        :disabled="submitWithdrawalLoading"
                        preloader
                        @click="finishOnappeal"
                    >
                        {{ $t('withdrawal.statuses.onappeal.actions.got') }}
                    </f7-button>
                </div>
            </template>
            <template v-else-if="
                withdrawal.status === P_WITHDRAWAL_STATUS.CANCELED ||
                withdrawal.status === P_WITHDRAWAL_STATUS.CONFIRMED
            ">
                <div class="bottom-block">
                    <f7-button
                        class="theme-type"
                        @click="closeView"
                    >
                        {{ $t('g.close') }}
                    </f7-button>
                </div>
            </template>
        </template>
    </transition>
</template>

<script setup lang="ts">
import {PropType, ref, toRef} from "vue";
import {P_WITHDRAWAL_STATUS} from "@/entities/enums/PWithdrawalStatus";
import WithdrawalOperation from "@models/operations/WithdrawalOperation";

const props = defineProps({
    withdrawal: {
        type: Object as PropType<WithdrawalOperation>,
        required: true
    },
});
const withdrawal = toRef(props, 'withdrawal');
const submitWithdrawalLoading = ref(false);
const emits = defineEmits(['closeView', 'openInfoPopup', 'confirmWithdrawal', 'finishOnappeal']);

const finishOnappeal = () => {
    submitWithdrawalLoading.value = true;
    emits('finishOnappeal', () => {
        submitWithdrawalLoading.value = false;
    })
}
const confirmPayment = () => {
    submitWithdrawalLoading.value = true;
    emits('confirmWithdrawal', () => {
        submitWithdrawalLoading.value = false;
    })
}
const closeView = () => {
    emits('closeView');
}
</script>

<style lang="scss">
.bottom-block {
    background-color: #FFFFFF;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 16px 16px calc(16px + var(--f7-safe-area-bottom));
    z-index: 100;
    display: flex;
    gap: 16px;

    a {
        flex: 2;

        //& :nth-child(1) {
        //    flex: 1 0 46px;
        //    background: #8E8E93;
        //}
    }

    &::before {
        content: '';
        position: absolute;
        background-color: var(--grey8);
        display: block;
        z-index: 15;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        height: 1px;
        width: 100%;
        transform-origin: 50% 100%;
        transform: scaleY(calc(1 / var(--f7-device-pixel-ratio)));
    }
}
</style>
